if (process.env.NODE_ENV === 'production') { // eslint-disable-line
	module.exports = require('./configureStore.prod');// eslint-disable-line
} else {
	module.exports = require('./configureStore.dev');// eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js